<template>
    <div class="text-center hidden sm:block">
        <div class="flex justify-center">
            <div class="m-3 w-60px">
                <img v-if="active1" src="@/assets/mission/1-active.svg" />
                <img v-else src="@/assets/mission/1-inactive.svg" />
                <div :class="active1 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.sun }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active2" src="@/assets/mission/2-active.svg" />
                <img v-else src="@/assets/mission/2-inactive.svg" />
                <div :class="active2 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.mon }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active3" src="@/assets/mission/3-active.svg" />
                <img v-else src="@/assets/mission/3-inactive.svg" />
                <div :class="active3 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.tue }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active4" src="@/assets/mission/4-active.svg" />
                <img v-else src="@/assets/mission/4-inactive.svg" />
                <div :class="active4 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.wed }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active5" src="@/assets/mission/5-active.svg" />
                <img v-else src="@/assets/mission/5-inactive.svg" />
                <div :class="active5 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.thu }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active6" src="@/assets/mission/6-active.svg" />
                <img v-else src="@/assets/mission/6-inactive.svg" />
                <div :class="active6 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.fri }}</div>
            </div>
            <div class="m-3 w-60px">
                <img v-if="active7" src="@/assets/mission/7-active.svg" />
                <img v-else src="@/assets/mission/7-inactive.svg" />
                <div :class="active7 ? 'text-a-yellow-e5aa17' : 'text-tc-gray-1'">{{ lbl.day.sat }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from '@/mixin/LocaleMixin'
export default {
    name: 'CheckinPoint',
    mixins: [LocaleMixin],
    data() {
        return {
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: false,
            active6: false,
            active7: false,
        };
    },

    methods: {
        validateCheckin: function(mission){
            for(let i in mission){
                if(mission[i].IsCompleted){
                    if(i == 0){
                        this.active1 = true
                    }
                    if(i == 1){
                        this.active2 = true
                    }
                    if(i == 2){
                        this.active3 = true
                    }
                    if(i == 3){
                        this.active4 = true
                    }
                    if(i == 4){
                        this.active5 = true
                    }
                    if(i == 5){
                        this.active6 = true
                    }
                    if(i == 6){
                        this.active7 = true
                    }
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
